module.exports = __webpack_public_path__ + "img/securityAlarm.059108c6.png";